import { render } from "./ArticlesGrid.vue?vue&type=template&id=924abe0a"
import script from "./ArticlesGrid.vue?vue&type=script&lang=js"
export * from "./ArticlesGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__